export const RefCode = {
  code() {
    const queryParameters = new URLSearchParams(window.location.search);
    const code = queryParameters.get("code");

    return code !== "null" && code ? code : null;
  },
};
